/**
 * Dev Feedback 모듈 활성 게이팅.
 * - import.meta.env.DEV === true (Vite dev 모드)
 * - 또는 VITE_APP_ENV in {local, dev}
 * production 빌드에서는 false → 트리 쉐이킹으로 컴포넌트 코드가 번들에서 제거됨.
 */
export const isDevFeedbackEnabled = (): boolean => {
  try {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const env = (import.meta as any).env;
    if (!env) return false;
    if (env.DEV === true) return true;
    if (env.VITE_APP_ENV === 'local' || env.VITE_APP_ENV === 'dev') return true;
    return false;
  } catch {
    return false;
  }
};

/** 현재 페이지 정보 스냅샷 — launcher 클릭 시점에 캡처하여 submit 까지 유지 */
export const capturePage = () => {
  if (typeof window === 'undefined') {
    return {
      pageUrl: '',
      pageTitle: '',
      pageId: '',
      viewport: '',
      userAgent: '',
      capturedAt: new Date().toISOString(),
    };
  }
  return {
    pageUrl: window.location.href,
    pageTitle: typeof document !== 'undefined' ? document.title : '',
    pageId:
      typeof document !== 'undefined'
        ? document.querySelector('main[id]')?.id ?? window.location.pathname
        : window.location.pathname,
    viewport: `${window.innerWidth}x${window.innerHeight}`,
    userAgent: typeof navigator !== 'undefined' ? navigator.userAgent : '',
    capturedAt: new Date().toISOString(),
  };
};

/** 서버에 함께 전송할 env 라벨 (local / dev / unknown) */
export const currentEnvLabel = (): string => {
  try {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const env = (import.meta as any).env;
    return env?.VITE_APP_ENV || (env?.DEV ? 'local' : 'unknown');
  } catch {
    return 'local';
  }
};
